<i class="icon-q icon-q-{{this.iconName}} {{this.className}} {{this.size}}"></i>
